import React from 'react';
import PropTypes from 'prop-types';
import { relativeDate } from 'Helpers/dates';
import { FormattedMessage as Translation } from 'react-intl';
import { Heading } from 'panamera-react-ui';
import { ICON_COLORS } from 'Constants/items';

export const MemberSince = ({ user, type = 'footnote', isClassified }) => {
    const date = user.created_at;
    const dateFormat = { month: 'short', year: 'numeric' };

    if (!date) {
        return null;
    }
    const values = { date: relativeDate(date, dateFormat, { suppressHydrationWarning: true }) };

    return (
        <div data-aut-id="memberSince">
            <Heading
                type={ type }
                tag="div"
                fontWeight="normal"
                color={ isClassified ? ICON_COLORS.PRIMARY_BASE : ICON_COLORS.BLACK }
            >
                <Translation id="memberSince" values={ values } />
            </Heading>
        </div>
    );
};

MemberSince.propTypes = {
    user: PropTypes.object.isRequired,
    type: PropTypes.string,
    isClassified: PropTypes.bool
};

export default MemberSince;
